

define({
    CA: [{
        id: 'policy',
        content: 'footer.policiesCA'
    }, {
        id: 'terms',
        content: 'footer.termsCA'
    }, {
        id: 'privacy',
        content: 'footer.privacyCA'
    }],

    BE: [{
        id: 'legal',
        content: 'footer.legal'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    DE: [{
        id: 'imprint',
        content: 'footer.DEImprint'
    }, {
        id: 'legal',
        content: 'footer.DELegal'
    }, {
        id: 'privacy',
        content: 'footer.DEPrivacy'
    }, {
        id: 'paymentdesc',
        content: 'footer.DEKeyPaymentDesc'
    }],

    ES: [{
        id: 'legal',
        content: 'footer.legal'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    FR: [{
        id: 'legal',
        content: 'footer.FRLegal'
    }, {
        id: 'useragreement',
        content: 'footer.FRUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.FRPrivacy'
    }],

    IT: [{
        id: 'legal',
        content: 'footer.legal'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    NL: [{
        id: 'legal',
        content: 'footer.legal'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    IE: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'useragreement',
        content: 'footer.userAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    APAC: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'useragreement',
        content: 'footer.userAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    EMEA: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'useragreement',
        content: 'footer.userAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    EM: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'useragreement',
        content: 'footer.userAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    LATAM: [{
        id: 'help',
        content: 'footer.help'
    }, {
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    AU: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    AT: [{
        id: 'imprint',
        content: 'footer.ATImprint'
    }, {
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    CH: [{
        id: 'imprint',
        content: 'footer.CHImprint'
    }, {
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    DK: [{
        id: 'useragreement',
        content: 'footer.DKUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    SE: [{
        id: 'useragreement',
        content: 'footer.SEUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    PL: [{
        id: 'useragreement',
        content: 'footer.PLUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    NO: [{
        id: 'useragreement',
        content: 'footer.NOUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    TR: [{
        id: 'useragreement',
        content: 'footer.TRUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    BR: [{
        id: 'help',
        content: 'footer.help'
    }, {
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    MX: [{
        id: 'help',
        content: 'footer.help'
    }, {
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    RU: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    DEFAULT: [{
        id: 'policy',
        content: 'footer.policies'
    }, {
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }]
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-page-components/src/footer/footerMap.js
// module id = ./components/xo-page-components/src/footer/footerMap.js
// module chunks = 1